import React from 'react';
import APPLICATION_NOTIFICATION_STRINGS from 'screens/Applications&WorkOrders/Applications/Components/Notification/Constants/notificationString';
import WORK_ORDER_NOTIFICATION_STRINGS from 'screens/Applications&WorkOrders/WorkOrders/Components/Notification/Constants/notificationString';
import showConfirmModal from 'components/ConfirmModal';
import { OperationType } from 'screens/Applications&WorkOrders/RouteAdmin';

const showDeleteConfirmModal = (
  operationType: OperationType,
  onOk: () => void
) => {
  showConfirmModal({
    title:
      operationType === OperationType.APPLICATION
        ? APPLICATION_NOTIFICATION_STRINGS.DELETE_CONFIRM_TITLE
        : WORK_ORDER_NOTIFICATION_STRINGS.DELETE_CONFIRM_TITLE,
    content: (
      <>
        You will permanently lose{' '}
        <span className="font-semibold">all data</span> from this record.
      </>
    ),
    okText: 'Delete record',
    cancelText: 'Go back',
    onOk
  });
};

export default showDeleteConfirmModal;
